// extracted by mini-css-extract-plugin
export default {"section":"wr_Mn","review":"rLsXt","gallery":"jNdKg","slide":"gczLY"};